import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asignacion-manual',
  templateUrl: './asignacion-manual.component.html',
  styleUrls: ['./asignacion-manual.component.scss']
})
export class AsignacionManualComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
